const howWorks = {
  title: 'How Prose works',
  elements: [
    {
      title: `1. Consultation`,
      content:
        'We learn about your hair in its true context, with factors like diet and ZIP code for a 360° understanding of what your hair actually needs.',
    },
    {
      title: `2. Customization`,
      content:
        'We create a full routine of custom products with all the nutrition and support your hair uniquely needs. You’ll love the results—guaranteed.',
    },
    {
      title: `3. Conversation`,
      content: (
        <>
          Use Review & Refine<sup>®</sup> to give us feedback about your formulas and keep us
          updated on your evolving hair goals. We’ll continually update your Prose to fit every move
          you make.
        </>
      ),
    },
  ],
};

export default howWorks;
